import React, { useEffect, useState } from "react";
import { Fade } from "react-awesome-reveal";
import { useTranslation } from "react-i18next";
import { isMobileDevice, validateImageFile } from "../../../utils";
import { Modal, Upload, message, Image, notification } from 'antd';
import type { GetProp, UploadProps } from 'antd';
import { showLoding } from "../../../utils/tool";
import { fileSignedUrl, fileUpload, shopBanner, shopDetail } from "../../../API";
import { useSelector } from "react-redux";
import Pagination from "../../../components/Pagination";
import { useNavigate } from "react-router";

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalIndex, setModalIndex] = useState(1)
  const handleOpenModal = (index: number) => {
    setModalIndex(index)
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const [imageUrl, setImage] = useState<string | null>(null);
  const beforeUpload = async (file: any) => {
    const validation = validateImageFile(file);
    if (!validation.isValid) {
      notification.open({
        message: validation.message,
      });
      return false;
    }  
    showLoding(true);
    fileUpload({
      file: file,
      bucketAccessLevel: 'PUBLIC'
    })
      .then((res: any) => {
        fileSignedUrl({
          path: res?.data
        }).then((res2: any) => {
          setImage(res2?.data);
        }).catch((err: any) => {
        })
      })
      .catch((err: any) => {
      })
      .finally(() => {
        showLoding(false);
      });
    return false;
  };

  const handleSubmit = () => {
    showLoding(true);
    shopBanner({
      "bannerUrl": imageUrl
    }).then(res => {
      message.success("上傳成功")
      handleCloseModal();
      handleLoad()
    }).catch(err => { }).finally(() => {
      showLoding(false);
    })
  }

  const token = useSelector((state: any) => state?.token)
  const [pageNum, setPageNum] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [productLi, setProductLi]: any = React.useState([])
  const [detail, setDetail]: any = React.useState<any>()
  const handleLoad = () => {
    shopDetail({
      "pageNum": pageNum,
      "pageSize": pageSize,
    }).then(res => {
      setDetail(res.data)
      setImage(res.data?.bannerUrl)
      setProductLi(res.data?.products?.records)
      setTotalPages(res.data?.products?.total)
    }).catch(err => {

    })
  }
  useEffect(() => {
    if (!token) {
      return
    }
    handleLoad()
  }, [token, pageNum]);

  const [totalPages, setTotalPages] = React.useState(0)

  const navigate = useNavigate()

  return (
    <div className="">
      {
        detail?.bannerUrl ?
          <img src={detail?.bannerUrl}
            className="h-[200px] w-full rounded-md object-cover"
            alt="" /> :
          <div className="h-[200px] w-full rounded-md bg-[#f6f5f1] flex items-center justify-center text-[#595959] text-[18px]">
            您還未上傳店鋪圖片
          </div>
      }
      <div> 
        <div className={`grid gap-10 ${isMobileDevice() ? 'grid-cols-1' : 'grid-cols-2'} 
        pt-[60px] pb-[50px]  h5:pt-[40px] `}>
          {
            productLi && productLi.map((item: any, index: number) => (
              <div key={index}>
                <Fade
                  cascade={true}
                  direction="up"
                  delay={200}
                  duration={800}
                  triggerOnce={true}
                >
                  <div className="pb-[10px] cursor-pointer hover:-translate-y-1 duration-200"
                    onClick={() => {
                      navigate(`/product?id=${item?.productId}&category=${'精選商品'}`)
                    }}>
                    <div
                      className="h-[153px] transition-transform duration-300 hover:scale-120 overflow-hidden"
                      style={{
                        backgroundImage: `url(${item?.imageUrl})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        borderTopLeftRadius: "10px",
                        borderTopRightRadius: "10px",
                      }}
                    ></div>
                    <div className="bg-[#f6f5f1] pt-[14px] px-[10px] pb-[14px]"
                      style={{
                        borderBottomLeftRadius: "10px",
                        borderBottomRightRadius: "10px",
                      }}>
                      <div className="text-[#595959] text-[18px] mb-[6px] line-clamp-1">{item?.title}</div>
                      <div className="text-[#181512] text-[16px] line-clamp-1">USD {item?.currentPrice}</div>
                    </div>
                  </div>
                </Fade>
              </div>
            ))
          }

          <div className="flex justify-center pb-[75px]">
            {
              Math.ceil(totalPages / pageSize) > 1 ?
                <Pagination
                  totalPages={Math.ceil(totalPages / pageSize)}
                  currentPage={pageNum}
                  onPageChange={(page: number) => setPageNum(page)}
                /> :
                ''
            }
          </div>
        </div>

        <div className="bg-[#f6f5f1] p-16 rounded-md">
          <div className="text-[#181512] text-[20px] font-bold pb-10">店鋪設置</div>
          {/* <div className="flex items-center py-12"
            style={{
              borderBottom: '1px solid rgb(204, 204, 204)'
            }}>
            <div className="flex-1 text-[#181512] text-[18px]">店鋪Logo</div>
            <div className="flex items-center text-[#595959] text-[16px] cursor-pointer"
              onClick={() => {
                handleOpenModal(1)
              }}>
              未設置
              <img src={require("../../../assets/image/icon1.png")} alt="" className="w-[16px]" />
            </div>
          </div> */}
          <div className="flex items-center py-12"
            style={{
              borderBottom: '1px solid rgb(204, 204, 204)'
            }}>
            <div className="flex-1 text-[#181512] text-[18px]">店鋪Banner</div>
            <div className="flex items-center text-[#595959] text-[16px] cursor-pointer"
              onClick={() => {
                handleOpenModal(2)
              }}>
              {detail?.bannerUrl ? '已設置' : '未設置'}
              <img src={require("../../../assets/image/icon1.png")} alt="" className="w-[16px]" />
            </div>
          </div>
          {/* <div className="flex items-center pt-12">
            <div className="flex-1 text-[#181512] text-[18px]">店鋪背景</div>
            <div className="flex items-center text-[#595959] text-[16px] cursor-pointer"
              onClick={() => {
                handleOpenModal(3)
              }}>
              未設置
              <img src={require("../../../assets/image/icon1.png")} alt="" className="w-[16px]" />
            </div>
          </div> */}
        </div>
      </div>

      <Modal
        title={`${modalIndex === 1 ? '上傳店鋪Logo' : modalIndex === 2 ? '上傳店鋪Banner' : '上傳店鋪背景'}`}
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        footer={null}
        onCancel={() => {
          handleCloseModal();
        }}
      >
        <div>
          <div className="flex justify-center pb-20">
            <Upload
              name="avatar"
              listType="picture-card"
              showUploadList={false}
              action=""
              beforeUpload={beforeUpload}
              className="avatar-uploader"
              maxCount={1}
            > 
              <div className="p-4">
              {imageUrl ? (
                  <img draggable={false} src={imageUrl}
                    className="rounded-md object-cover"
                    alt="avatar" style={{ width: '100%' }} />
              ) : (
                ''
              )}
              </div>
            </Upload>
          </div>
          <div className=" pb-20">
            {
              imageUrl ?
                <img
                  className="rounded-md object-cover w-full h-[145px] mx-auto" 
                  src={imageUrl}
                />
                : ''
            }
          </div>
          <div className="flex justify-center">
            <div className="bg-[#000] rounded-[4px] inline-block px-[50px] py-[16px] text-[#fff] text-[18px] cursor-pointer
                    "
              onClick={() => handleSubmit()}
            >
              確認上傳
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ComponentName;
